import Pusher from 'pusher-js';
import PusherBatchAuthorizer from 'pusher-js-auth';

type Props = {
  pusherKey: string;
  isDev: boolean;
  baseUrl: string;
};

let pusherInstance: Pusher | null = null;

export function initPusher({ pusherKey, isDev, baseUrl }: Props) {
  if (isDev) {
    Pusher.logToConsole = true;
  }

  if (!pusherInstance) {
    pusherInstance = new Pusher(pusherKey, {
      cluster: 'eu',
      forceTLS: true,
      // this package was patched using patch-package to support session based auth
      // see file pusher-js-auth+4.0.1.patch
      authorizer: PusherBatchAuthorizer,
      authEndpoint: `${baseUrl}/pusher/auth`,
    });
  }

  return pusherInstance;
}
